import { render, staticRenderFns } from "./EmployeeMilitaryInfo.vue?vue&type=template&id=222b55c8&scoped=true"
import script from "./EmployeeMilitaryInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeMilitaryInfo.vue?vue&type=script&lang=js"
import style0 from "./EmployeeMilitaryInfo.vue?vue&type=style&index=0&id=222b55c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222b55c8",
  null
  
)

export default component.exports